<template>
  <div class="mb-3">
    <v-card dark class="elevation-5" style="width: 250px">
      <v-list class="py-0" style="background-color: #000">
        <v-list-tile>
          <v-list-tile-title
            style="text-align: center; font-size: 20px; color: white"
            >RIDER</v-list-tile-title
          >
        </v-list-tile>
      </v-list>
      <v-list class="py-0" style="overflow: hidden">
        <v-list-group
          v-for="item in filteredSidebar"
          v-model="item.active"
          :key="item.title"
          :prepend-icon="item.action"
          no-action
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="item.alert_all">
              <v-btn
                fab
                color="primary"
                style="height: 25px; width: 25px"
                class="black--text"
                >{{
                  item.alert_all == 1
                    ? count_rider.user
                    : count_rider.request_money
                }}</v-btn
              >
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile
            v-for="subItem in filterSubSidebar(item)"
            :key="subItem.title"
            :to="subItem.url"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="subItem.alert">
              <v-btn
                fab
                color="primary"
                style="height: 25px; width: 25px"
                class="black--text"
                >{{
                  item.alert_all == 1
                    ? count_rider.user
                    : count_rider.request_money
                }}</v-btn
              >
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      interval: null,
      items: [
        {
          alert_all: 1,
          action: "perm_identity",
          title: "Rider",
          permission_name: "rider_list",
          items: [
            {
              permission_name: "rider_user",
              title: "Rider list",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/rider/riderinhouse",
            },
            {
              permission_name: "rider_approve",
              alert: 1,
              title: "Rider approve",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/rider/riderapprove",
            },
          ],
        },
        {
          alert_all: 2,
          action: "money",
          title: "Money",
          permission_name: "rider_money",
          items: [
            {
              permission_name: "rider_wallet",
              title: "Wallet",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/rider/wallet",
            },
            {
              permission_name: "rider_request",
              alert: 2,
              title: "Request cash",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/rider/request_cash",
              alert: true,
            },
            {
              permission_name: "rider_withdraw",
              title: "Withdraw cash",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/rider/withdraw_cash",
            },
            {
              permission_name: "rider_refill",
              title: "Refill credit",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/rider/refill_credit",
            },
          ],
        },
        {
          action: "percent",
          title: "Commission",
          permission_name: "rider_commission",
          items: [
            {
              permission_name: "rider_deposit_commission",
              title: "Deposit",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/rider/deposit_commission",
            },
            {
              permission_name: "rider_withdraw_commission",
              title: "Withdraw",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/rider/withdraw_commission",
            },
            {
              permission_name: "rider_penalty",
              title: "Penalty",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/rider/penalty",
            },
          ],
        },
        {
          permission_name: "rider_setting",
          action: "settings",
          title: "Setting",
          items: [
            {
              permission_name: "rider_bank",
              title: "Bank",
              url:
                "/weserve_admin_login/control/" +
                this.$store.state.backOffice.province +
                "/rider/setting_bank",
            },
          ],
        },
      ],
    };
  },
  methods: {
    filterSubSidebar(item) {
      return item.items.filter((val) => {
        for (let val2 in this.permission.rider[item.permission_name]) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
    async getData() {
      await this.$store.dispatch("fetchRiderListBack/getCountRider");
    },
  },
  destroyed() {
    clearInterval(this.interval);
  },
  computed: {
    ...mapState({
      count_rider: (state) => state.fetchRiderListBack.count_rider,
      permission: (state) => state.permission,
    }),
    filteredSidebar() {
      return this.items.filter((val) => {
        for (let val2 in this.permission.rider) {
          if (val2 == val.permission_name) return val;
        }
      });
    },
  },
  created() {
    let vm = this;
    this.getData();
    this.interval = setInterval(function () {
      vm.getData();
    }, 300000);
  },
};
</script>


